import { Component, OnInit, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { HeaderData } from 'src/app/_models/header-data';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { PolicyService } from 'src/app/_services/policy.service';
import { BehaviorSubject } from 'rxjs';
import { EndorsementCriteria } from './_models/endorsement-criteria';
import { SortableDirective, SortEvent } from 'src/app/_directives/sortable.directive';
import { StatusCode, Modules, PSIOperators } from 'src/app/_common/_enum/module.enum';
import { RESULTS_NOT_FOUND, ENDORSEMENT_MSGS } from 'src/app/_common/product-config';
import { EndorsementService } from '../_services/endorsement.service';
import { environment } from 'src/environments/environment';
import LogRocket from 'logrocket';

@Component({
  selector: 'app-endorsement-history',
  templateUrl: './endorsement-history.component.html',
  styleUrls: ['./endorsement-history.component.scss']
})
export class EndorsementHistoryComponent implements OnInit {

  resultsNotFound = RESULTS_NOT_FOUND;
  private endorsementMsgs = ENDORSEMENT_MSGS; //Using it in HTML

  private loading: boolean = false;
  private accountLoading: boolean = false;
  private hasAccess: boolean = true;
  private canEndorse: boolean = false;
  public policyNumber: string;
  public policyStatus: string;
  private reportLoading: boolean = false;
  private selectedPolicy: any;
  private selectedAccount: any;
  private _total$ = new BehaviorSubject<number>(0);
  private endorsementList = [];
  private endorsements = [];
  private criteria: EndorsementCriteria;

  
  @ViewChildren(SortableDirective) headers: QueryList<SortableDirective>;
  @ViewChild("lossRunErrorModal", {static: false}) lossRunErrorModal;
  @ViewChild("lossRunMessageModal", {static: false}) lossRunMessageModal;
  
  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  
  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private endorsementService: EndorsementService, private policyService: PolicyService) { }

  ngOnInit() {
    this.headerData = new HeaderData();
    this.criteria = new EndorsementCriteria();
    //Getting Policy Number for State params
    this.route.paramMap.subscribe(params => {      
      if(this.policyNumber !== params.get("id").toString()){
        this.policyNumber = params.get("id").toString();
      }
      
      this.setHeaderData();
      this.retrieveBasicHeaderData(); //Retrieve the basic details of policy and Set the Header..
    });
  }
  
  retrieveBasicHeaderData(){
    /* Setting Headers Starts */
    this.headerData = new HeaderData();

    this.selectedPolicy = this.policyService.getPolicyData();
    if(!this.selectedPolicy || this.selectedPolicy.policyNumber !== this.policyNumber){
      this.loading = true;
      this.accountLoading = true;
      let accountByPolicySubscription =  this.policyService.fetchAccountByPolicy(this.policyNumber).subscribe(policy=>{
        this.selectedPolicy = policy;
        if(this.selectedPolicy){
          this.policyService.storeAccountData({"accountName": this.selectedPolicy.accountName, "accountNumber": this.selectedPolicy.accountNumber, "accountEndorsementsTab": null});
        }
        this.policyService.storePolicyData(this.selectedPolicy);
        this.setHeaderData(this.selectedPolicy);
      }, error=>{
        this.loading = false;
        this.accountLoading = false;
        this.selectedPolicy = null;
      });

      this.endorsementService.runningServices.push(accountByPolicySubscription);
    }else{
      this.setHeaderData(this.selectedPolicy);
    }
    /* Setting Headers Ended */
  }
  
  setHeaderData(details?: any){
    this.headerData.pageTitle = this.policyNumber;
    if(details){
      let pipe = new DatePipe('en-US');
      this.headerData.breadcrumb = [{ itemName: details.accountName, itemLink: (details.accountNumber != undefined)?("/accounts/" + details.accountNumber + "/policies"):""}, {itemName:"Policies", itemLink:""}];
      this.headerData.detailMenu = [{label: "Account #", description: this.selectedPolicy.accountNumber}, {label: "Effective", description: pipe.transform(details.policyEffectiveDate, 'MM/dd/yyyy')}, {label: "Expiration", description: pipe.transform(details.policyExpirationDate, 'MM/dd/yyyy')}];

      this.resetCriteria();
      if(this.selectedPolicy.showEndorsements){
        this.accountLoading = false;
        this.fetchEndorsements(); 
      }else{
        this.router.navigate(["policies/"+this.selectedPolicy.policyNumber]);
      }
    }
    this.endorsementService.header = this.headerData;
  }
  resetCriteria(){    
    this.criteria.policyNumber = this.selectedPolicy.policyNumber;
    this.criteria.accountNumber = this.selectedPolicy.accountNumber;
    this.criteria.sortBy = "policyEffectiveDate";
    this.criteria.sortOrder = "desc";
    this.criteria.filterBy = [{
      "FilterColumnName": "PolicyExpirationDate",
      "FilterValue": "All"
    }];
  }
  fetchEndorsements(){
    this.loading = true;
    this.hasAccess = true;
    let claimsByPolicySubscription = this.endorsementService.fetchEndorsements(this.criteria.accountNumber, this.criteria.policyNumber).subscribe((_endorsements:any) => {
      this.loading = false;
      this.hasAccess = true;
      this.canEndorse = _endorsements.allowNewRequests;
      this._total$.next(_endorsements.endorsementsTasks.length);
      this.endorsementList = _endorsements.endorsementsTasks;
      console.log(this.endorsementList);
      this.endorsements = JSON.parse(JSON.stringify(this.endorsementList));// Object.assign({}, this.claimList);
      
      this.endorsements = this.doSort(this.criteria.sortBy, this.criteria.sortOrder);
      console.log(this.endorsements);

      console.log(this._total$);
    },error=>{
      this.loading = false;
      this.endorsements = null;
      this.canEndorse = false;
      this.hasAccess = !(error.status == StatusCode.NoAccess);
    });

    this.endorsementService.runningServices.push(claimsByPolicySubscription);
  }
  get total$() { return this._total$.asObservable(); }

  get ModuleEnum(){ return Modules; }
  get PSIOperatorsEnum(){ return PSIOperators;  }

  /* ***Sorting Code*** */
  compare(v1, v2) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  onSort({column, direction}: SortEvent) {
    // resetting other headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = '';
      }
    });

    if (direction !== '') {
      this.criteria.sortOrder = direction;
      this.criteria.sortBy = column;
      this.criteria.pageNo = 1;

      console.log("Call WebAPI to sort " + column + " column in " + direction + " order");
      return this.doSort(column, direction);
    }
  }

  doSort(column, direction){
    return this.endorsements.sort((a, b) => {
      const res = this.compare(a[column], b[column]);
      return direction === 'asc' ? res : -res;
    });
  }
  /* Sorting Code */

  downloadLossRunReport(type: string){
    this.reportLoading = true;
    let number = type === "policy" ? this.selectedPolicy.policyNumber : this.selectedPolicy.accountNumber;
    this.policyService.openModal('none', this.lossRunMessageModal);
    
    this.policyService.downloadLossRunReport(number, (type+"Number")).subscribe(data=>{
      this.reportLoading = false;
      this.policyService.closeModal();
    },
    error => {
      this.reportLoading = false;
      let hasOpenModals = this.policyService.hasOpenModals();
      if (hasOpenModals) {
        this.policyService.closeModal();
      }
      if(error.status == StatusCode.NoAccess) {        
        setTimeout(() => {
          this.policyService.openModal('none', this.lossRunErrorModal);
        }, 50);
        
      } 
      
      if(error.status == StatusCode.InternalServer) {
        setTimeout(() => {
          this.policyService.openModal('error', 'none');
        }, 50);
      }
      console.warn("Download Loss Run Report Error : " + error);
    });
  }
  
  getEndorsementStatusClass(status){
    let _status = "";
    if(status){
      if(status.toLowerCase().includes("quoted")){
        _status = "quoted";
      }else if(status.toLowerCase().includes("declined") && status.toLowerCase().includes("agent")){
        _status = "declinedbyagent";
      }else if(status.toLowerCase().includes("declined") && status.toLowerCase().includes("uw")){
        _status = "declinedbyuw";
      }else if(status.toLowerCase() == "in review"){
        _status = "inreview";
      }else if(status.toLowerCase().includes("input needed")){
        _status = "inputneeded";
      }else if(status.toLowerCase().includes("invalid") || status.toLowerCase().includes("duplicate")){
        _status = "invalid";
      }else{
        _status = status.toLowerCase();
      }
    }

    return _status;
  }

  goToEndorsementRequest(){
    if(environment.logRocketKey){
      LogRocket.log("(LogRocket) StartedEndorsementRequest : " + true);
      let loggedInUser = this.endorsementService.getLoggedInProfile();
      LogRocket.identify(loggedInUser.UID.toString(), {
        StartedEndorsementRequest: true
      });
    }
    this.endorsementService.endorsement = null;
    this.router.navigate(["policies/"+this.selectedPolicy.policyNumber+"/requestendorsement"]);
  }

  goToFAQs(){
    this.endorsementService.endorsement = null;
    this.router.navigate(["faq"]);
  }


  ngOnDestroy() {
    this.endorsementService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}
